<template>
  <div>
    <banner />
    <div class="company">
      <div class="titleSub">Company Profile</div>
      <div class="title wow animate__animated durationTime animate__fadeInUp">公司简介</div>
      <div class="desc ">
        <div
          class="content wow animate__animated durationTime animate__fadeInUp"
          style="text-indent: 2em;"
        >
          柠檬网联是中国数智园区、无线网络解决方案提供商及运营服务商。历经10年发展，已经设计研发了智慧园区、无线网络相关一系列的软件、硬件和平台，融合物联网、大数据、云计算、人工智能等新一代信息技术，形成了以网络为基础，以数智校园、数智厂园为应用的“一体两翼”的发展格局，以网络化、数字化、智能化持续助力学校和企业园区的数字化转型升级。
        </div>
        <div class="content wow animate__animated durationTime animate__fadeInUp">
          公司总部设立在深圳，在经济最发达的二十多个省份设立了三十多个分支机构，业务覆盖全国两百多个城市，为数千家高校、职校和制造业企业提供规、建、营、维一体化网络服务，累计服务超过3000万学生和蓝领用户。公司已经成为中国校企园区无线网络细分市场规模最大的龙头企业，2023年获得国家级专精特新“小巨人”称号。
        </div>
        <div class="content wow animate__animated durationTime animate__fadeInUp">
          公司先后获得腾讯、广发信德、招商银科、分享投资、中风投等国内知名机构的投资，于2016年新三板挂牌-柠檬网联（835924）。
        </div>
      </div>
      <div class="slogan wow animate__animated durationTime animate__fadeInUp">
        用户至上、开放共赢、创新突破、靠谱
      </div>
      <div class="slogan-title wow animate__animated durationTime animate__fadeInUp">
        连接美好世界，畅享智慧生活
      </div>
    </div>
    <div class="qua">
      <div class="titleSub">Qualifications</div>
      <div class="title wow animate__animated durationTime animate__fadeInUp">企业资质</div>
      <img
        class="wow animate__animated durationTime animate__fadeInUp"
        src="../../assets/image/about/qua.png"
      />
    </div>
    <div class="partner">
      <div class="title">
        中国领先的数智园区、无线网络解决方案提供商及运营服务商
      </div>
      <div class="case">
        <div class="box">
          <div class="item">
            <div class="num">千万</div>
            <div class="desc">覆盖用户</div>
          </div>
          <div class="item">
            <div class="num">
              <span class="number">
                <count-to
                  separator=""
                  :startVal="0"
                  :endVal="200"
                  :duration="500"
                  ref="count1"
                ></count-to> </span
              ><span class="suffix">+</span>
            </div>
            <div class="desc">城市</div>
          </div>
          <div class="item">
            <div class="num">
              <span class="number">
                <count-to
                  separator=""
                  :startVal="0"
                  :endVal="2000"
                  :duration="500"
                  ref="count2"
                ></count-to> </span
              ><span class="suffix">+</span>
            </div>
            <div class="desc">B端客户</div>
          </div>
          <div class="item">
            <div class="num">上百所</div>
            <div class="desc">中高职学校</div>
          </div>
          <div class="item">
            <div class="num">唯一</div>
            <div class="desc">
              富士康、比亚迪、立讯、昌硕等全国<br />无线网络合作伙伴
            </div>
          </div>
        </div>
        <div class="imgList">
          <div
            class="imgListItem"
            v-for="item in partnerList"
            :key="item.column"
          >
            <div
              class="imgItem  wow animate__animated durationTime animate__fadeInUp"
              v-for="item2 in item.children"
              :key="item2.src"
            >
              <img class="img" :src="item2.src" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <development />
    <div class="inv">
      <img src="../../assets/image/about/inv.png" />
      <div class="right">
        <div class="titleSub">Qualifications</div>
        <div class="title wow animate__animated durationTime animate__fadeInUp">
          企业资质
        </div>
        <div class="desc">
          公司成功获得腾讯、广发信德、分享投资、中国风险投资有限公司、吉富创投等国内知名机构数亿元投资，充分展示了投资界对公司业务模式和发展潜力的高度认可，为公司的快速规模发展提供了强大动力。
        </div>
        <img style="width: 4.65rem;" src="../../assets/image/about/logo.png" />
      </div>
    </div>
  </div>
</template>

<script>
import banner from "../about/components/banner";
import development from "../about/components/development.vue";
import countTo from "vue-count-to";
import { WOW } from "wowjs";

export default {
  name: "index",
  components: {
    banner,
    development,
    countTo
  },
  data() {
    return {
      partnerList: [
        {
          column: 1,
          children: [
            {
              src: require("@/assets/image/about/school1.png")
            },
            {
              src: require("@/assets/image/about/logo2.png")
            },
            {
              src: require("@/assets/image/about/logo3.png")
            }
          ]
        },
        {
          column: 2,
          children: [
            {
              src: require("@/assets/image/about/logo4.png")
            },
            {
              src: require("@/assets/image/about/logo5.png")
            },
            {
              src: require("@/assets/image/about/logo6.png")
            },
            {
              src: require("@/assets/image/about/logo7.png")
            },
            {
              src: require("@/assets/image/about/logo8.png")
            }
          ]
        },
        {
          column: 3,
          children: [
            {
              src: require("@/assets/image/about/logo9.png")
            },
            {
              src: require("@/assets/image/about/logo10.png")
            },
            {
              src: require("@/assets/image/about/logo11.png")
            },
            {
              src: require("@/assets/image/about/logo12.png")
            }
          ]
        },
        {
          column: 4,
          children: [
            {
              src: require("@/assets/image/about/logo13.png")
            },
            {
              src: require("@/assets/image/about/logo14.png")
            },
            {
              src: require("@/assets/image/about/logo15.png")
            },
            {
              src: require("@/assets/image/about/logo16.png")
            },
            {
              src: require("@/assets/image/about/logo17.png")
            }
          ]
        },
        {
          column: 5,
          children: [
            {
              src: require("@/assets/image/about/logo18.png")
            },
            {
              src: require("@/assets/image/about/logo19.png")
            },
            {
              src: require("@/assets/image/about/logo20.png")
            },
            {
              src: require("@/assets/image/about/logo21.png")
            }
          ]
        },
        {
          column: 6,
          children: [
            {
              src: require("@/assets/image/about/logo22.png")
            },
            {
              src: require("@/assets/image/about/logo23.png")
            },
            {
              src: require("@/assets/image/about/logo24.png")
            },
            {
              src: require("@/assets/image/about/logo25.png")
            },
            {
              src: require("@/assets/image/about/logo26.png")
            }
          ]
        }
      ]
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    // init wow
    const wow = new WOW({
      boxClass: "wow", //需要执行动画元素的Class
      animateClass: "animated_lightSpeedIn", //animation.css动画的Class
      offset: 0, //距离可视区域多少开始执行动画
      mobile: true, //是否在移动设备执行动画
      live: true //异步加载的内容是否有效
    });
    wow.init();
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      const counts = [
        this.$refs.count1,
        this.$refs.count2,
        this.$refs.count3,
        this.$refs.count4
      ];
      counts.forEach(item => {
        const top = item.$el.getBoundingClientRect().top;
        if (top < window.innerHeight) {
          if (!this[`${item.$vnode.data.ref}Counted`]) {
            item.start();
            this[`${item.$vnode.data.ref}Counted`] = true;
          }
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.company {
  width: 100%;
  background: url("../../assets/image/about/about-company.png") center no-repeat;
  background-size: cover;
  padding-left: 2.18rem;
  padding-top: 1rem;
  padding-bottom: 1.63rem;
  .title {
    font-size: 0.44rem;
    font-weight: 500;
    text-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    position: relative;
    color: #333333;
    display: inline-block;
    margin-top: 0.3rem;
  }
  .titleSub {
    position: absolute;
    font-size: 0.44rem;
    font-weight: 500;
    //color: rgba(255, 255, 255, 0.51);
    color: #c8c8c8;
    text-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    letter-spacing: 0.02rem;
  }
  .slogan {
    margin-top: 1.71rem;
    font-weight: 600;
    font-size: 0.41rem;
    color: #3b5377;
  }
  .slogan-title {
    font-weight: 400;
    font-size: 0.18rem;
    color: #333333;
    margin-top: 0.53rem;
  }
  .desc {
    width: 8.17rem;
    .content {
      font-weight: 400;
      font-size: 0.18rem;
      color: #333333;
      line-height: 0.34rem;
      margin-top: 0.4rem;
    }
  }
}

.qua {
  padding: 1rem 2.26rem 0.8rem 2.26rem;
  background: url("../../assets/image/about/qua-bg.png") center no-repeat;
  background-size: cover;
  display: flex;
  align-items: center;
  flex-direction: column;
  .title {
    font-size: 0.44rem;
    font-weight: 500;
    text-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    position: relative;
    color: #ffffff;
    display: inline-block;
    margin-top: 0.3rem;
  }
  .titleSub {
    position: absolute;
    font-size: 0.44rem;
    font-weight: 500;
    //color: rgba(255, 255, 255, 0.51);
    color: #c8c8c8;
    text-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    letter-spacing: 0.02rem;
  }
  img {
    width: 100%;
    margin-top: 1.02rem;
  }
}
.partner {
  background: url("../../assets/image/about/partner.png") center no-repeat;
  background-size: cover;
  padding: 1rem 2.2rem 1rem 2.18rem;
  .title {
    text-align: center;
    font-weight: 500;
    font-size: 0.34rem;
    color: #ffffff;
  }
  .case {
    display: flex;
    justify-content: space-between;
    margin-top: 0.2rem;
    align-items: center;
    .box {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .item {
        display: flex;
        align-items: baseline;
        margin-bottom: 0.6rem;
        &:last-child {
          margin-bottom: 0;
        }
        .num {
          font-family: Skia, Skia;
          font-weight: bold;
          font-size: 0.55rem;
          color: #fef100;
          margin-right: 0.18rem;
          position: relative;
          .number {
            font-size: 0.78rem;
            text-shadow: 0.05rem 0.05rem 0.02rem rgba(110, 123, 39, 0.8);
            letter-spacing: 0.05rem;
          }
          .suffix {
            font-size: 0.4rem;
            vertical-align: super;
            margin-left: -0.25rem;
          }
        }
        .desc {
          font-weight: 400;
          font-size: 0.27rem;
          color: #ffffff;
        }
      }
    }
    .imgList {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 0.9rem;
      .imgListItem {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin: 0 0.2rem;
        .imgItem {
          width: 1rem;
          height: 1rem;
          background: rgba(#ffffff, 0.3);
          border-radius: 0.1rem;
          margin: 0.25rem 0;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
          .img {
            width: 0.74rem;
            height: auto;
            transition: all 0.3s ease-in-out;
          }
          &:hover img{
            transform: scale(1.2);
          }
        }
      }
    }
  }
}
.inv {
  display: flex;

  img {
    width: 60%;
  }
  .right {
    width: 40%;
    padding: 1rem 2.14rem 0.22rem 0.8rem;
    .title {
      font-size: 0.44rem;
      font-weight: 500;
      text-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
      position: relative;
      color: #333333;
      display: inline-block;
      margin-top: 0.3rem;
    }
    .titleSub {
      position: absolute;
      font-size: 0.44rem;
      font-weight: 500;
      //color: rgba(255, 255, 255, 0.51);
      color: #c8c8c8;
      text-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
      letter-spacing: 0.02rem;
    }
  }
  .desc {
    width: 4.86rem;
    font-weight: 400;
    font-size: 0.18rem;
    color: #333333;
    margin-top: 0.8rem;
    line-height: 0.34rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/about/index.vue